var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"font-weight-bold",attrs:{"to":{ name: _vm.routeName, params: { id: _vm.data }}}},[_vm._v(" #"+_vm._s(_vm.data)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }